import React, { useState } from 'react';
import PropTypes from 'prop-types';
import CmsInlineEdit from '../../components/Cms/CmsInlineEdit';

/** Both FAQ routes use the same CMS data and accessible refreshed controls. */
const BrandRefreshFaq = ({ content, idPrefix }) => {
  const [selectedIndex, setSelectedIndex] = useState(0);
  const [expandedIndex, setExpandedIndex] = useState(null);
  const section = content[selectedIndex] || content[0] || { children: [] };

  return (
    <div data-part="faq-layout">
      <div data-part="faq-categories" aria-label="FAQ categories">
        {content.map((category, index) => (
          <button
            key={category.cmsKeyId || index}
            type="button"
            data-part="faq-category"
            aria-pressed={category === section}
            onClick={() => {
              setSelectedIndex(index);
              setExpandedIndex(null);
            }}
          >
            <CmsInlineEdit cmsNode={category} type="list" showContent showChilds>
              {category.value}
            </CmsInlineEdit>
          </button>
        ))}
      </div>
      <div data-part="faq-questions">
        {(section.children || []).map((question, index) => {
          const isOpen = expandedIndex === index;
          const questionId = `${idPrefix}-question-${selectedIndex}-${index}`;
          const answerId = `${idPrefix}-answer-${selectedIndex}-${index}`;
          return (
            <section key={question.cmsKeyId || index} data-part="faq-item">
              <h2>
                <button
                  id={questionId}
                  type="button"
                  data-part="faq-question"
                  aria-expanded={isOpen}
                  aria-controls={answerId}
                  onClick={() => setExpandedIndex(isOpen ? null : index)}
                >
                  <span data-part="faq-label">
                    <CmsInlineEdit cmsNode={question}>{question.value}</CmsInlineEdit>
                  </span>
                  <span data-part="faq-symbol" aria-hidden="true">{isOpen ? '−' : '+'}</span>
                </button>
              </h2>
              <div id={answerId} data-part="faq-answer" hidden={!isOpen} aria-labelledby={questionId}>
                {(question.children || []).map((answer, answerIndex) => (
                  <CmsInlineEdit key={answer.cmsKeyId || answerIndex} cmsNode={answer}>
                    {answer.value}
                  </CmsInlineEdit>
                ))}
              </div>
            </section>
          );
        })}
      </div>
    </div>
  );
};

BrandRefreshFaq.propTypes = {
  content: PropTypes.arrayOf(PropTypes.shape({
    cmsKeyId: PropTypes.string,
    value: PropTypes.string,
    children: PropTypes.array
  })).isRequired,
  idPrefix: PropTypes.string.isRequired
};

export default BrandRefreshFaq;
